<template>
  <div>
    <wv-checklist :options="options" v-model="checkedItems"></wv-checklist>

    <div class="weui-cell">
      <wv-button type="primary" @click="btnSave()">保存</wv-button>
    </div>
  </div>
</template>
<script>
import { Toast } from "we-vue";
export default {
  name: "setnews",
  data: function() {
    return {
      checkedItems: [],
      options: []
    };
  },
  created: function() {
    this.InitNews();
  },
  methods: {
    InitNews: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/initnews", {
          params: { typeCode: 37 }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.checkedItems = rep.Data.messageType;
              if (rep.Data.options.length > 0) {
                rep.Data.options.forEach(element => {
                  if (element.value == 2 || element.value == 4) {
                    this.options.push(element);
                  }
                });
              }
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    btnSave: function() {
      var checkInfo = JSON.stringify(this.checkedItems);
      this.$http
        .post(
          this.GLOBAL.BASE_URL +
            "api/login/setNewSave?messageType=" +
            checkInfo,
          {},
          { emulateJSON: true }
        )
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              Toast.success("保存成功");
              this.$router.push("/app/us");
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/set/setnews.vue